export function getRegionIds(goals) {
    if (!Array.isArray(goals) || !goals.length) {
        return '';
    }

    let regionIds = [];
    goals.forEach((goal) => {
        const regions = goal?.goal?.traffic_restrictions?.regions;
        if (Array.isArray(regions) && regions.length) {
            regionIds = regionIds.concat(regions);
        }
    });

    return regionIds.join(',');
}



export function removeParams() {
    return {
        created_at_from: undefined,
        created_at_to: undefined,
        type: undefined,
        tab: undefined,
        nameLink: undefined
    };
};
